import React, { useCallback, useEffect, useState } from "react";
import { Switch, NavLink, Route, Redirect, useRouteMatch, useHistory } from "react-router-dom";
import UploadDrag from "../../components/UploadDragger";
import { useTranslation } from "../../context";
import Layout from "../../Layout";
import MainTabs from "../../components/MainTabs";
import ListRecent from "./ListRecent";
import ListMyshare from "./ListMyshare";
import ListShares from "./ListShares";
import Sidebar from "./sidebar";
import ShortcutList from "../Shortcut";
import { PermissionEnum } from "../../const";
import "../../common/index.less";
import "./index.less";
import events from "../../context/events";
export default function () {
  const lang = useTranslation();
  const { path, url } = useRouteMatch();
  const [isLoadMore, setLoadMore] = useState(true);
  const backTop = () => {
    const node = document.getElementsByClassName("myspace-list-wrap")[0];
    if (!node) {
      return;
    }
    node.scrollTop = 0;
  };
  const getButtom = useCallback(({ isLoadMore }: any) => {
    setLoadMore(isLoadMore);
  }, []);
  useEffect(() => {
    events.on("list.reload", backTop);
    events.on("list.pagination", getButtom);
    return () => {
      events.off("list.reload", backTop);
      events.off("list.pagination", getButtom);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onScroll = useCallback(
    (event: any) => {
      if (!isLoadMore) {
        return;
      }
      const sTop = event.target.scrollTop || 0;
      const cHight = event.target.clientHeight || 0;
      const sHight = event.target.scrollHeight || 0;
      const diff = sHight * 0.08;
      if (Math.floor(sTop) + cHight >= sHight - 4) {
        event.target.scrollTop = sHight - diff - 10 - cHight;
        return;
      }
      if (sTop + cHight >= sHight - diff) {
        events.emit("joyspace:onButtom");
      }
    },
    [isLoadMore]
  );
  return (
    <Layout>
      <div className="joyspace-drop">
        <UploadDrag permissions={[PermissionEnum.PAGE_CREATE]} from="HOME" />
        <div className="joyspace-header">
          <Layout.Breadcrumbs text={lang("home.title")} />
          <Sidebar />
        </div>
        <div className="myspace-list-wrap joyspace-card-ppup-container" onScroll={onScroll}>
          <ShortcutList />
          <MainTabs>
            <NavLink
              log-analysis-data="xtbg_jzb_joyspace_home_1676548210761|5"
              onDragStart={() => false}
              to={`${url}/recent`}
            >
              {lang("home.tabs.recent")}
            </NavLink>
            <NavLink
              onDragStart={() => false}
              to={`${url}/shares`}
              log-analysis-data="xtbg_jzb_joyspace_home_1676548210761|7"
            >
              {lang("home.tabs.shares")}
            </NavLink>
            <NavLink
              onDragStart={() => false}
              to={`${url}/myshare`}
              log-analysis-data="xtbg_jzb_joyspace_home_1676548210761|6"
            >
              {lang("home.tabs.myshare")}
            </NavLink>
          </MainTabs>
          <div className="joyspace-home-container" data-listwrap>
            <Switch>
              <Route exact path={`${path}`} component={() => <Redirect to={`${path}/recent`} />} />
              <Route path={`${path}/recent`} component={ListRecent} />
              <Route path={`${path}/myshare`} component={ListMyshare} />
              <Route path={`${path}/shares`} component={ListShares} />
              <Redirect to={`${path}/recent`} />
            </Switch>
          </div>
        </div>
      </div>
    </Layout>
  );
}
